<template>
  <v-row v-if="!isLoading">
    <v-col cols="12" md="12">
      <dashboard-statistics-card :all-counts="allCounts"></dashboard-statistics-card>
    </v-col>
    <v-col cols="12" sm="12" md="6">
      <dashboard-card-platform-users
        :stats="dashboardStats"
        :login-activity="loginActivity"
        :loading="isLoading"
      ></dashboard-card-platform-users>
    </v-col>
    <v-col cols="12" md="6">
      <dashboard-card-login-activity
        :login-activity="loginActivity"
        :loading="isLoading"
      ></dashboard-card-login-activity>
    </v-col>
  </v-row>
  <v-row v-else>
    <v-col cols="12" md="12">
      <v-skeleton-loader type="card" height="120"></v-skeleton-loader>
    </v-col>
    <v-col cols="12" sm="6" md="6">
      <v-skeleton-loader type="image" height="400"></v-skeleton-loader>
    </v-col>
    <v-col cols="12" md="6">
      <v-skeleton-loader type="image" height="400"></v-skeleton-loader>
    </v-col>
  </v-row>
</template>

<script>
import auth from '@/services/AuthService';
import { mesazhiIGabimit } from '@/utils/error-message';
import DashboardStatisticsCard from './DashboardStatisticsCard.vue';
import DashboardCardPlatformUsers from './DashboardCardPlatformUsers.vue';
import DashboardCardLoginActivity from './DashboardCardLoginActivity.vue';

export default {
  components: {
    DashboardStatisticsCard,
    DashboardCardPlatformUsers,
    DashboardCardLoginActivity,
  },
  data() {
    return {
      isLoading: false,
      loginActivity: {},
      dashboardStats: {},
      allCounts: [
        { title: 'Schools',   total: '' },
        { title: 'Guardians', total: '' },
        { title: 'Drivers',   total: '' },
        { title: 'Students',  total: '' },

      ],
    };
  },
  mounted() {
    this.fetchDashboardStatistics();
  },
  methods: {
    fetchDashboardStatistics() {
      this.isLoading = true;
      axios
        .get('/admin-dashboard/all')
        .then((response) => {
          this.allCounts[0].total = response.data.totalSchools;
          this.allCounts[1].total = response.data.totalGuardians;
          this.allCounts[2].total = response.data.totalDrivers;
          this.allCounts[3].total = response.data.totalStudents;
          this.dashboardStats = response.data;
          this.loginActivity = response.data.loginActivity || {};
        })
        .catch((error) => {
          this.$notify({
            title: 'Error',
            text: mesazhiIGabimit(error),
            type: 'error',
          });
          auth.checkError(
            error.response.data.message,
            this.$router,
            this.$swal
          );
        })
        .then(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
